import PanelDropOffContainer from './PanelDropOffContainer';

export default PanelDropOffContainer;



// WEBPACK FOOTER //
// ./src/components/molecules/PanelDropOff/index.js